<form class="container" [formGroup]="loginForm" (ngSubmit)="login()">
  <div class="header">
    <div class="logo">
      <img src="https://nichepharma-assets.fra1.cdn.digitaloceanspaces.com/tacitapp_logo_default.png" alt="" />
    </div>
  </div>

  <main>
    <div class="form">
      <h3>{{dictionary.get('Login')}}<span class="dot">.</span></h3>
      <div class="content">
        <div>
          <label for="email">{{dictionary.get('LoginUsername')}}</label>
          <app-input
            type="email"
            placeholder="{{dictionary.get('EnterUsername')}}"
            size="sm"
            margin="w-100 mt-2"
            formControlName="email"
            [isError]="emailInvalid"
          />
          @if (emailInvalid) {
          <small class="message error-message">
            {{
              emailRequired
                ? dictionary.get('Username-required')
                : emailFormatInvalid
                ? dictionary.get('Username-format-invalid')
                : ""
            }}
          </small>
          }
        </div>

        <div>
          <label for="password">{{dictionary.get('Password')}}</label>
          <app-input
            type="password"
            placeholder="{{dictionary.get('Enter-Password')}}"
            size="sm"
            margin="mt-2"
            formControlName="password"
            [isError]="passwordInvalid"
            [showPasswordToggle]="true"
          />
          @if (passwordInvalid) {
          <small class="message error-message">{{dictionary.get('Password-required')}}</small>
          }
        </div>

        <button
          buttonTheme="primary"
          buttonType="regular"
          class="w-100 mt-3 d-flex"
          type="submit"
          [disabled]="isLoading"
        >
          @if (!isLoading) { {{dictionary.get('Login')}} } @else {
          <app-inline-loader color="light" size="lg" />
          }
        </button>
      </div>
    </div>

    <div class="mockups">
      <img src="/assets/mockups.webp" alt="" />
    </div>
  </main>

  <div class="circle"></div>
  <div class="circles top-right">
    <img src="/assets/circles_square.svg" alt="circles" />
  </div>
  <div class="circles bottom-left">
    <img src="/assets/circles_square-1.svg" alt="circles" />
  </div>
</form>
